var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"watermark-wrapper"},_vm._l((150),function(i){return _c('div',{key:i,staticClass:"watermark-item",style:({
      fontSize: _vm.fontSize,
      color: _vm.color,
      opacity: _vm.opacity,
      transform: ("rotate(" + _vm.rotate + "deg)")
    })},[_vm._v("\n    "+_vm._s(_vm.text)+"\n  ")])}),0)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-500efb2e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Watermark.vue
// module id = null
// module chunks = 